import { Component, OnInit, ViewChild } from '@angular/core';
import { WidgetHostDirective } from "app/shared/widget/widget-host.directive";
import { Product } from "app/calculators/Product";
import { WidgetHostService } from "app/shared/widget/widget-host-service";
import { CalculatorService } from "app/calculators/calculator.service";
import { HttpService } from "app/shared/services/http.service";
import { ActivatedRoute, Params, Router } from "@angular/router";
import * as emiGlobals from 'app/globals';
import { WidgetReportItem } from "app/shared/widget/widget-item";
import { QuestionsComponent } from "app/calculators/home-loan-comparison-calculator/questions/questions.component";
import { SubProductsQuestionComponent } from "app/company-details/sub-products-question/sub-products-question.component";

@Component({
  selector: 'app-sub-products',
  templateUrl: './sub-products.component.html',
  styleUrls: ['./sub-products.component.css']
})
export class SubProductsComponent implements OnInit {

  @ViewChild('products', { read: WidgetHostDirective }) products;
  productList = [];
  dataList: any;
  statusList: any;
  showStatus: boolean;
  product: Product = new Product();
  showProduct: boolean;
  url: any;
  customProduct: any;
  productId: any;
  productsList: any;

  constructor(public httpService: HttpService, public widgetHostService: WidgetHostService,
    public calculatorService: CalculatorService, public route: ActivatedRoute,
    public router: Router) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const bankId = +params['bankId'];
      this.getAllProductsByBankId(bankId);
    });
    // this.route.params.subscribe(data => {
    //   this.url = data['calculator-slug'];
    // });
    // this.getAllProducts(id);
    // this.httpService.getAll(emiGlobals.productByUrlCategory + '/' + this.url).subscribe(
    //   result => {
    //     this.customProduct = result.sub_products[0];
    //     this.calculatorService.activeProduct = this.customProduct.id;
    //     this.product.productId = this.customProduct.id;
    //     this.product.questionType = this.customProduct.question_type;
    //     this.product.listId = this.customProduct.list_type;
    //   });
    this.calculatorService.SearchCategory = '2';
  }
  onClickOfProduct(data, i) {
    this.showProduct = false;
    this.showStatus = true;
    this.product.productId = data.id;
    this.product.questionType = data.question_type;
    this.product.bankId = data.bank_id;
    this.product.listId = data.list_type;
  }
  onClickOfStatus(status) {
    this.product.statusId = status.id;
    this.calculatorService.SearchCategory = '3';
    this.getQuestionsByProductId(this.product.productId, this.product.questionType, this.product.bankId, 15, this.product.listId);
  }
  private getQuestions(productId: any, questionType: any, bankId: any, questionSetId: any, listId: any) {
    return [
      new WidgetReportItem(QuestionsComponent, {
        configData: this.dataList, productId: productId, questionType: questionType, bankId: bankId,
        questionSetId: questionSetId, listId: listId
      }),
    ];
  }

  getQuestionsByProductId(productId, questionType, bankId, questionSetId, listId) {
    debugger
    // if (questionType === 1) {
      this.httpService.getById(emiGlobals.productQuestionUrl + '/' + productId + '/' + this.product.statusId).subscribe(result => {
        debugger
        this.dataList = result;
        let postItems: any = [];
        postItems = this.getQuestions(productId, questionType, bankId, questionSetId, listId);
        this.widgetHostService.loadReportComponent(this.products.viewContainerRef, postItems[0]);
      });
    // }
    //  else {
    //   debugger
    //   this.dataList = [];
    //   let postItems: any = [];
    //   debugger
    //   postItems = this.getQuestions(productId, questionType, bankId, questionSetId, listId);
    //   this.widgetHostService.loadReportComponent(this.products.viewContainerRef, postItems[0]);
    // }
  }

  onTabClick(id) {
    this.calculatorService.noOffer = false;
    this.calculatorService.SearchCategory = id;
  }
  onClickOfCategory(id: any, category: any) {
    this.showProduct = true;
    this.showStatus = false;
    this.calculatorService.SearchCategory = id;
    this.productList = category.sub_product;
    this.httpService.getAll(emiGlobals.statusUrl).subscribe(result => {
      this.statusList = result.status;
    });
  }
  getAllProducts(id) {
    debugger
    this.showStatus = false;
    this.httpService.getById(emiGlobals.productsBasedOnCompanyGroup + '/' + id).subscribe(
      products => {
        console.log('----result', products);
        products.forEach(product => {
          console.log('----element', product);
          this.httpService.getById(emiGlobals.productById + '/' + product.sub_product_id).subscribe(
            data => {
              this.calculatorService.SearchCategory = '2';
              this.showProduct = true;
              this.productList.push({
                'id': data[0].id,
                'product': data[0].product,
                'question_type': data[0].question_type,
                'list_type': data[0].list_type

              });
              console.log('rethis.productListsult----' , this.productList);
            }
          );
        });
      }
    )
  
    this.httpService.getAll(emiGlobals.statusUrl).subscribe(result => {
      this.statusList = result.status;
    });
  }

  getAllProductsByBankId(bankId) {
    this.calculatorService.SearchCategory = '2';
    this.showProduct = true;
    this.httpService.getById(emiGlobals.productsByBankId + '/' + bankId).subscribe(
      result => {
        this.productsList = result;
      });
      this.httpService.getAll(emiGlobals.statusUrl).subscribe(result => {
        this.statusList = result.status;
      });
    }
}



// WEBPACK FOOTER //
// ./src/app/company-details/sub-products/sub-products.component.ts